<template>
  <avtalat-select
    id="kundgrupp"
    v-model:value="kundgrupp"
    label="Kundgrupp"
    :disabled="disabled"
  >
    <option v-for="(item, index) in options" :key="index" :value="item.id">
      {{ item.label }}
    </option>
  </avtalat-select>
</template>

<script setup lang="ts">
import type { KundgruppType } from "@/composables/KundserviceAppApiClient";
import type { Option } from "@/types/form";

const kundgrupp = defineModel<KundgruppType>();

defineProps<{
  disabled?: boolean | null | undefined;
  options: Option[];
}>();
</script>
